function initDoplnkySlider(okno) {
  const $karty = $(okno).find(".shopcode-doplnky__karty");
  if (!$karty.length || $karty.hasClass("slick-initialized")) return;
  $karty.children(".shopcode-doplnky__karta").wrap("<div></div>");
  $karty.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 550, settings: { slidesToShow: 1, variableWidth: true } },
    ],
  });
  setTimeout(function () {
    $karty.slick("setPosition");
    if ($.colorbox && typeof $.colorbox.resize === "function") $.colorbox.resize();
  }, 300);
}

document.addEventListener("ShopcodeDoplnkyOkno", function (e) {
  if (!e.detail.vOkneShoptetu) return;
  setTimeout(function () {
    initDoplnkySlider(e.detail.okno);
  }, 50);
});
